export enum BulkTipVariant {
  TotalTip = 'bulk-tip-variant-total-tip',
  TipEach = 'bulk-tip-variant-tip-each',
  Custom = 'bulk-tip-variant-custom',
}
